import 'arrive';
import $ from 'jquery';
import Sticky from 'sticky-js';

document.arrive("body.page_carrello, body.page_cart", { existing: true }, function () {

    function getCartTotalWeight() {
        let totalWeight = 0;
        $('.cart_item').each(function() {
            const weight = parseFloat($(this).find('.cart-item-weight-data').data('weight')) || 0;
            const qty = parseInt($(this).find('.cart-item-weight-data').data('qty')) || 0;
            totalWeight += weight * qty;
        });
        return totalWeight;
    }

    function updateCheckoutButton(totalWeight) {
        const $checkoutBtn = $('.checkout-button');
        const $inlineMsg = $('#cart-weight-inline-message');

        if (totalWeight > 5) {
            // Show inline message (content comes from PHP/ACF)
            if ($inlineMsg.length) {
                $inlineMsg.show();
            }

            // Disable checkout
            $checkoutBtn.addClass('disabled').attr('aria-disabled', 'true');
            if ($checkoutBtn.is('a')) {
                $checkoutBtn.css('pointer-events', 'none');
            }
        } else {
            // Hide inline message
            if ($inlineMsg.length) {
                $inlineMsg.hide();
            }

            // Enable checkout
            $checkoutBtn.removeClass('disabled').removeAttr('aria-disabled');
            if ($checkoutBtn.is('a')) {
                $checkoutBtn.css('pointer-events', '');
            }
        }
    }

    function checkCartWeight() {
        const totalWeight = getCartTotalWeight();
        updateCheckoutButton(totalWeight);
        return totalWeight;
    }

    // ✅ 1. Controllo iniziale al caricamento
    $(window).on('load', function() {
        checkCartWeight();
    });

    // Removed: manual update_cart button reliance (handled via AJAX updates)

    // ✅ 3. Blocca checkout se peso > 5kg
    $(document).on('click', '.checkout-button', function(e) {
        const totalWeight = getCartTotalWeight();
        if (totalWeight > 5) {
            e.preventDefault();
            return false;
        }
    });

    // Quantity adjustments via custom +/- controls (AJAX)
    $(document).on('click', '.adjustments-input .plus, .adjustments-input .minus', function (e) {
        e.preventDefault();

        const $btn = $(this);
        const $item = $btn.closest('.cart_item');
        if ($item.length === 0) return;

        const $qtyInput = $item.find('.cart_item__qty input.qty');
        const $copies = $item.find('.product-item__adjustments .copies');
        const $weightData = $item.find('.cart-item-weight-data');
        const $lineSubtotal = $item.find('.cart_item__subtotal');

        if ($qtyInput.length === 0) return;

        const step = parseInt($qtyInput.attr('step')) || 1;
        const min = parseInt($qtyInput.attr('min')) || 0;
        const maxAttr = $qtyInput.attr('max');
        const max = maxAttr ? parseInt(maxAttr) : null;
        let current = parseInt($qtyInput.val()) || 0;

        const isPlus = $btn.is('.plus');
        const isMinus = $btn.is('.minus');

        let next = current;
        if (isPlus) {
            next = current + step;
            if (max !== null && !isNaN(max)) {
                next = Math.min(next, max);
            }
        } else if (isMinus) {
            next = current - step;
            next = Math.max(next, 0); // allow 0 to trigger removal
        }

        // If next is 0, call remove endpoint instead
        if (next === 0) {
            const cartItemKey = $item.find('.cart_item__qty input[name^="cart["]').attr('name').match(/cart\[(.+?)\]/)[1];
            ajaxRemoveItem(cartItemKey, $item);
            return;
        }

        const cartItemKey = $item.find('.cart_item__qty input[name^="cart["]').attr('name').match(/cart\[(.+?)\]/)[1];
        ajaxUpdateQty(cartItemKey, next, {
            onBefore: () => {
                // optimistic UI
                $qtyInput.val(next);
                if ($copies.length) {
                    $copies.contents().filter(function(){ return this.nodeType === 3; }).first().replaceWith(String(next) + ' ');
                    const $label = $copies.find('.label');
                    if ($label.length) {
                        const $form = $('form.woocommerce-cart-form');
                        const lang = ($form.data('lang') || 'en').toString().toLowerCase();
                        const isItalian = lang.startsWith('it');
                        $label.text(next === 1
                            ? (isItalian ? 'copia' : 'copy')
                            : (isItalian ? 'copie' : 'copies')
                        );
                    }
                }
                if ($weightData.length) $weightData.attr('data-qty', next);
                $btn.addClass('loading');
            },
            onSuccess: (resp) => {
                if (resp && resp.success) {
                    if ($lineSubtotal.length && resp.line_subtotal_html !== undefined) {
                        $lineSubtotal.html(resp.line_subtotal_html);
                    }
                    updateCartTotalsAndWeight(resp);
                    renderAjaxNotices(resp);
                }
            },
            onComplete: () => {
                $btn.removeClass('loading');
            },
        });
    });

    // Remove item via AJAX
    $(document).on('click', '.cart_item__remove a.remove', function(e) {
        e.preventDefault();
        const $link = $(this);
        const $item = $link.closest('.cart_item');
        const cartItemKey = $link.data('cart_item_key') || ($item.find('.cart_item__qty input[name^="cart["]').attr('name').match(/cart\[(.+?)\]/)[1]);
        ajaxRemoveItem(cartItemKey, $item, $link);
    });

    function ajaxUpdateQty(cartItemKey, qty, hooks = {}) {
        hooks.onBefore && hooks.onBefore();
        $.ajax({
            url: $('form.woocommerce-cart-form').data('ajax-url'),
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'hb_update_cart_qty',
                cart_item_key: cartItemKey,
                qty: qty,
                nonce: $('form.woocommerce-cart-form').data('nonce')
            }
        }).done(function(resp){
            hooks.onSuccess && hooks.onSuccess(resp);
        }).fail(function(){
            // optional: show notice
        }).always(function(){
            hooks.onComplete && hooks.onComplete();
        });
    }

    function ajaxRemoveItem(cartItemKey, $item, $trigger) {
        if ($trigger) $trigger.addClass('loading');
        $.ajax({
            url: $('form.woocommerce-cart-form').data('ajax-url'),
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'hb_remove_cart_item',
                cart_item_key: cartItemKey,
                nonce: $('form.woocommerce-cart-form').data('nonce')
            }
        }).done(function(resp){
            if (resp && resp.success) {
                // remove row
                $item.slideUp(150, function(){ $(this).remove(); });
                updateCartTotalsAndWeight(resp);
                renderAjaxNotices(resp);
                renderEmptyCartIfNeeded(resp);
            }
        }).fail(function(){
            // optional: show notice
        }).always(function(){
            if ($trigger) $trigger.removeClass('loading');
        });
    }

    function renderAjaxNotices(resp) {
        if (resp && typeof resp.notices_html !== 'undefined') {
            const $noticesWrap = $('.custom-cart__woocommerce-notices');
            if ($noticesWrap.length) {
                $noticesWrap.html(resp.notices_html);
            }
        }
        // bind undo links
        bindUndoLinks();
    }

    function updateCartTotalsAndWeight(resp) {
        // Update subtotal block if present
        if (resp.cart_subtotal_html !== undefined) {
            $('.cart-subtotal .font-sans').contents().filter(function(){ return this.nodeType === 3; }).remove();
            // keep the grey VAT INCLUDED span, replace following price html
            const $subtotalContainer = $('.cart-subtotal .font-sans');
            const $grey = $subtotalContainer.find('.grey');
            $subtotalContainer.html('');
            if ($grey.length) $subtotalContainer.append($grey);
            $subtotalContainer.append(' ' + resp.cart_subtotal_html);
        }

        // Update weight + checkout state
        const totalWeight = parseFloat(resp.total_weight) || 0;
        updateCheckoutButton(totalWeight);
    }

    function renderEmptyCartIfNeeded(resp) {
        if (resp && typeof resp.empty_cart_html !== 'undefined' && resp.empty_cart_html) {
            // Hide right column collaterals
            const $sticky = $('#sticky-cart');
            if ($sticky.length) { $sticky.hide(); }
            $('.cart-collaterals').hide();

            // Remove all cart items and inject empty html in left column
            const $leftCol = $('.custom-cart__left');
            if ($leftCol.length) {
                $leftCol.find('.cart_item').remove();
                // Avoid duplicate empty message
                $leftCol.find('.cart-empty').remove();
                $leftCol.append(resp.empty_cart_html);
            }
        }
    }

    // Delegated handler for undo links in notices
    function bindUndoLinks() {
        $(document).off('click.hbUndo', '.hb-undo-remove');
        $(document).on('click.hbUndo', '.hb-undo-remove', function(e){
            e.preventDefault();
            const $a = $(this);
            const pid = parseInt($a.data('product_id'), 10) || 0;
            const qty = parseInt($a.data('quantity'), 10) || 1;
            if (!pid) return;
            $a.addClass('loading');
            $.ajax({
                url: $('form.woocommerce-cart-form').data('ajax-url'),
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'hb_undo_remove_cart_item',
                    product_id: pid,
                    quantity: qty,
                    nonce: $('form.woocommerce-cart-form').data('nonce')
                }
            }).done(function(resp){
                if (resp && resp.success) {
                    updateCartTotalsAndWeight(resp);
                    renderAjaxNotices(resp);
                    // Per consistenza del markup delle righe, esegui reload leggero
                    window.location.reload();
                }
            }).always(function(){
                $a.removeClass('loading');
            });
        });
    }

    // Initial bind for undo (in case notices are already present)
    bindUndoLinks();

    window.addEventListener('load', function() {
        const rightCol = document.getElementById('sticky-cart');
        if (!rightCol) return;

        function updateStickyMargin() {
            const vh = window.innerHeight;
            const elementHeight = rightCol.offsetHeight;
            const marginTop = (vh / 2) - (elementHeight / 2);
            rightCol.setAttribute('data-margin-top', Math.max(marginTop, 0));
        }

        // Calcola subito il margine
        updateStickyMargin();

        // Inizializza Sticky-js DOPO aver impostato il margine (desktop)
        const sticky = new Sticky('.sticky-element');

        // Fade-in
        setTimeout(() => {
            rightCol.classList.remove('sticky-hidden');
            rightCol.classList.add('sticky-visible');
        }, 1000);

        // Aggiorna al resize
        window.addEventListener('resize', () => {
            updateStickyMargin();
            sticky.update();
        });

        // (rimosso) nessuna logica sticky mobile
        return;
    });

});
